import { useQuery } from "@rocicorp/zero/react";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { BoardProvider } from "@/features/tasks/store/board.store";
import { useCurrentWorkspace } from "@/features/workspaces/store/workspace.store";
import { useZero } from "@/hooks/use-zero";

export const Route = createFileRoute("/_app/w/$slug/settings/boards/$boardId")({
  component: RouteComponent,
});

function RouteComponent() {
  const workspaceId = useCurrentWorkspace((w) => w.id);
  const { boardId } = Route.useParams();

  const zero = useZero();
  const [board] = useQuery(
    zero.query.boards
      .where("workspaceId", workspaceId)
      .where("id", boardId)
      .related("lists")
      .one(),
  );

  if (!board) {
    return null;
  }

  return (
    <BoardProvider board={board}>
      <Outlet />
    </BoardProvider>
  );
}
